import { ComboPaySynchronizationFieldNameArray } from '@libs/data-access/entities'

export const shouldDisplayForComboPay = (
  canRead: boolean | undefined,
  inputName: string
) => {
  if (!canRead) {
    return false
  }

  return (
    ComboPaySynchronizationFieldNameArray as ReadonlyArray<string>
  ).includes(inputName)
}
